import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { IFillDataWizardBuy, TKeyOfDataWizardBuy } from "../../..";
import FeaturesFacilityStep, {
  IDataFeatures,
} from "../../../../../../../shared/wizard/steps/featuresStep";

interface ISureSwapStepBuy_2 {
  onChange: (data: Partial<IFillDataWizardBuy>) => void;
  data: Partial<IFillDataWizardBuy>;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SureSwapStepBuy_2 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: ISureSwapStepBuy_2) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.sureSteps.swap.step_1);
    onReset([
      "debt",
      "arrest",
      "encumbrance",
      "childrenOwn",
      "privatization",
    ]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.sureSteps.swap.step_3);
  };

  return (
    <div>
      <FeaturesFacilityStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data as IDataFeatures}
      />
    </div>
  );
};

export default SureSwapStepBuy_2;
